import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { AudiPlatformProvider, Loader } from '@audi/audi-ui-react';
import { LoaderVariant } from '@audi/audi-ui-react/dist/types/components/Loader/Loader.types';
import React from 'react';
import ReactDOM from 'react-dom';

@Component({
    selector: 'app-audi-loader',
    template: ''
})
export class AudiLoaderComponent implements AfterViewInit, OnChanges, OnDestroy {
    //https://react.ui.audi/?path=/story/components-loaders-overview--page
    @Input() variant = 'circular';

    ElementToShow = () => (
        <AudiPlatformProvider>
            <div style={{ textAlign: 'center' }}>
                <Loader variant={this.variant as LoaderVariant} />
            </div>
        </AudiPlatformProvider>
    );

    constructor(private hostRef: ElementRef) { }

    ngOnChanges(changes: SimpleChanges): void {
        //console.log('ngOnChanges: ' + this.hostRef.nativeElement);
        this.render();
    }

    ngAfterViewInit(): void {
        //console.log('ngAfterViewInit');
        this.render();
    }

    ngOnDestroy(): void {
        //console.log('ngOnDestroy');
        ReactDOM.unmountComponentAtNode(this.hostRef.nativeElement);
    }

    private render() {
        ReactDOM.render(<this.ElementToShow />, this.hostRef.nativeElement);
    }
}
